module.exports = __webpack_public_path__ + "img/bg.9c6b4878.jpg";